<plex-title size="sm" titulo="SUSPENDER TURNO">
    <plex-button *ngIf="!suspendio" size="sm" type="success" icon="check" [disabled]="!motivoSuspensionSelect.select"
                 (click)="suspenderTurno()"></plex-button>
    <!--TODO: chequear que todos los mensajes a enviar tuvieron una respuesta-->
</plex-title>
<ng-container class="text-white" *ngIf="showSuspenderTurno">
    <div class="row">
        <div class="col-4">
            <label>Hora del Turno</label>
        </div>
        <div [ngClass]="{'col-6': !agenda.enviarSms, 'col-4': agenda.enviarSms}">
            <label>Paciente</label>
        </div>
        <div *ngIf="agenda.enviarSms" class="col-4">
            <label>Enviar notificación</label>
        </div>
    </div>

    <div class="row" *ngFor="let turno of turnosSeleccionados; let i = index">
        <div class="col-4">
            {{turno.horaInicio | date: 'H:mm'}} hs
        </div>
        <div [ngClass]="{'col-6': !agenda.enviarSms, 'col-4': agenda.enviarSms}">
            <span *ngIf="turno.paciente?.id">{{turno.paciente | nombre }}</span>
            <span *ngIf="!turno.paciente?.id && turno.estado !== 'turnoDoble'">sin paciente asignado</span>
            <span *ngIf="turno.estado === 'turnoDoble'">turno doble</span>
        </div>
        <div *ngIf="agenda.enviarSms" class="col-4" (click)="seleccionarTurno(turno)">
            <span *ngIf="!turno.paciente?.id">-</span>
            <span *ngIf="!estaSeleccionado(turno) && turno.paciente?.id">
                <plex-icon size="lg" class="ml-5" name="checkbox-blank-outline"></plex-icon>
            </span>
            <span *ngIf="estaSeleccionado(turno) && turno.paciente?.id">
                <plex-icon size="lg" type="info" class="ml-5" name="checkbox-marked"></plex-icon>
            </span>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <plex-select [(ngModel)]="motivoSuspensionSelect.select" name="motivoSuspension" [data]="motivoSuspension"
                         label="Motivo de Suspensión" placeholder="Seleccione un motivo de suspensión" idField="key"
                         labelField="nombre" [required]="true">
            </plex-select>
        </div>
    </div>
</ng-container>